import { useContext, useRef } from 'react';
import PropTypes from 'prop-types';

import CaseRelationPropTypes from '@/shared/prop-types/CaseRelationPropTypes';
import { CaseType } from '~/common/enums';

import AddCaseRelationFormBody from './AddCaseRelationFormBody';
import { AppContext } from '@/shared/context/context';

const propTypes = {
  buildingId: PropTypes.string,
  caseRelationToUpdate: CaseRelationPropTypes,
  caseType: PropTypes.oneOf([
    CaseType.Case,
    CaseType.Complaint,
    CaseType.Repair,
    CaseType.InsuranceClaim,
    CaseType.Sales,
  ]),
  currentCaseRelations: PropTypes.arrayOf(CaseRelationPropTypes),
  editMode: PropTypes.bool,
};

const AddUpdateCaseRelationForm = ({
  buildingId = null,
  caseType,
  currentCaseRelations = [],
  caseRelationToUpdate = null,
  editMode = false,
}) => {
  const {
    currentTeam: { createNormalCaseAskForClient, createInsuranceClaimAskForClient },
  } = useContext(AppContext);

  const popperContainer = useRef();

  const relationAskForClient =
    caseType === CaseType.InsuranceClaim
      ? createInsuranceClaimAskForClient
      : createNormalCaseAskForClient;

  return (
    <>
      <AddCaseRelationFormBody
        buildingId={buildingId}
        currentCaseRelations={currentCaseRelations}
        editMode={editMode}
        caseRelationToUpdate={caseRelationToUpdate}
        askForClient={relationAskForClient}
        popperContainer={popperContainer}
      />
      <div ref={popperContainer} />
    </>
  );
};

AddUpdateCaseRelationForm.propTypes = propTypes;

export default AddUpdateCaseRelationForm;
